import { useListOrder } from '../../filter';
import { AddOnOrderKey } from '../domain';

export const useAddOnListOrder = () => {
  return useListOrder(AddOnOrderKey, 'addOnOrderBy', true);
};
